"use client";

// src/index.cc.ts
import {
  skipToken,
  useApolloClient,
  useBackgroundQuery
} from "@apollo/client/index.js";

// src/DataTransportAbstraction/transportedOptions.ts
import { gql } from "@apollo/client/index.js";
import { print } from "@apollo/client/utilities/index.js";
function deserializeOptions(options) {
  return {
    ...options,
    // `gql` memoizes results, but based on the input string.
    // We parse-stringify-parse here to ensure that our minified query
    // has the best chance of being the referential same query as the one used in
    // client-side code.
    query: gql(print(gql(options.query)))
  };
}

// src/index.cc.ts
import { useMemo } from "react";
import invariant from "ts-invariant";
var handledRequests = /* @__PURE__ */ new WeakMap();
function SimulatePreloadedQuery({
  options,
  result,
  children,
  queryKey
}) {
  const client = useApolloClient();
  if (!handledRequests.has(options)) {
    const id = `preloadedQuery:${client["queryManager"].generateQueryId()}`;
    handledRequests.set(options, id);
    invariant.debug(
      "Preloaded query %s started on the server, simulating ongoing request",
      id
    );
    client.onQueryStarted({
      type: "started",
      id,
      options
    });
    result.then((results) => {
      invariant.debug("Preloaded query %s: received events: %o", id, results);
      for (const event of results) {
        client.onQueryProgress({ ...event, id });
      }
    });
  }
  const bgQueryArgs = useMemo(() => {
    const { query, ...hydratedOptions } = deserializeOptions(
      options
    );
    return [
      query,
      // If we didn't pass in a `queryKey` prop, the user didn't use the render props form and we don't
      // need to create a real `queryRef` => skip.
      // Otherwise we call `useBackgroundQuery` with options in this component to create a `queryRef`
      // and have it soft-retained in the SuspenseCache.
      queryKey ? {
        ...hydratedOptions,
        queryKey
      } : skipToken
    ];
  }, [options, queryKey]);
  useBackgroundQuery(...bgQueryArgs);
  return children;
}
export {
  SimulatePreloadedQuery
};
export const built_for_browser = true;
//# sourceMappingURL=index.cc.js.map